import { render, staticRenderFns } from "./wtTagsList.component.vue?vue&type=template&id=97e09e08&"
import script from "./wtTagsList.component.vue?vue&type=script&lang=js&"
export * from "./wtTagsList.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports